module.exports = __webpack_public_path__ + "static/img/ID.4379c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/ID.png
// module id = xwXN
// module chunks = 1